/***
 * @file:
 * @author: caojianping
 * @Date: 2021-03-08 11:51:36
 */
import { Component, Input, OnInit } from '@angular/core';

import { defaultLogo } from './pcp-default-logo';

@Component({
  selector: 'dt-pcp-theme-logo',
  templateUrl: './pcp-theme-logo.component.html',
  styleUrls: ['./pcp-theme-logo.component.scss'],
})
export class PcpThemeLogoComponent implements OnInit {
  defaultLogo = defaultLogo;
  @Input() isCollapsed: boolean;

  constructor() {}

  ngOnInit() {}
}
